/* eslint-disable */
import Vue from 'vue';
import moment from 'moment';

//Vue.prototype.moment = moment

const dateFilter = function (value) {
  var formattedDate = moment.utc(value, "YYYY-MM-DD").format('DD/MM/YYYY');
  return formattedDate;
};

const dateFilterWithFormat = function (value, format) {
  return value;
};
const dateFilterFormatUKDisplay = function (value) {

  var date = moment(value, 'YYYY-MM-DDTHH:mm:ss.SSS').format('DD/MM/YYYY');
  return date;
};

Vue.filter('dateFilter', dateFilter);
Vue.filter('dateFilterFormatUKDisplay', dateFilterFormatUKDisplay);

export default dateFilter;